import React from "react";
import { X, Image as ImageIcon } from "lucide-react";

interface ImagePreviewItemProps {
  imageUrl: string;
  index: number;
  isCoverImage: boolean;
  onRemove: (index: number) => Promise<void>;
  onSetCover: (index: number) => void;
}

export const ImagePreviewItem = ({
  imageUrl,
  index,
  isCoverImage,
  onRemove,
  onSetCover
}: ImagePreviewItemProps) => {
  return (
    <div className="relative group">
      <img
        src={imageUrl}
        alt={`Preview ${index + 1}`}
        className={`w-full aspect-square object-cover rounded-lg ${
          isCoverImage ? 'ring-2 ring-gebeya-pink' : ''
        }`}
      />
      <div className="absolute top-2 right-2 flex gap-2">
        <button
          type="button"
          onClick={() => onSetCover(index)}
          className={`p-1.5 rounded-full shadow-md transition-opacity ${
            isCoverImage
              ? 'bg-gebeya-pink text-white opacity-100'
              : 'bg-white text-gray-600 opacity-0 group-hover:opacity-100'
          }`}
        >
          <ImageIcon className="w-4 h-4" />
        </button>
        <button
          type="button"
          onClick={async () => {
            try {
              await onRemove(index);
            } catch (error) {
              console.error("Error removing image:", error);
            }
          }}
          className="p-1.5 bg-white rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <X className="w-4 h-4 text-gray-600" />
        </button>
      </div>
    </div>
  );
};
